import { createReducer } from '@reduxjs/toolkit'
import { extend } from 'lodash-es'
import ActionTypes from '@constants/action_types.js'
import { defaultColorScheme } from '@helpers/color_scheme_helpers.js'

export const initialState = {
  current: 'default', // can either be an entity key or a colorscheme
  editable: defaultColorScheme(), // the colorscheme used when editing
  // the colorscheme entities
  entities: {
    default: defaultColorScheme(),
  },
}

export const colorScheme = createReducer(initialState, builder => {
  builder
    .addCase(ActionTypes.CURRENT_COLOR_SCHEME_CHANGE, (state, action) => changeCurrentColorSchemeChange(state, action))
    .addCase(ActionTypes.EDITABLE_COLOR_SCHEME_CHANGE, (state, action) => editableColorSchemeChange(state, action))
})

function changeCurrentColorSchemeChange(state, action) {
  const { payload: colorSchemeUpdates } = action
  state.current = extend(defaultColorScheme(), state.current, colorSchemeUpdates)
  return state
}

function editableColorSchemeChange(state, action) {
  const { payload: colorSchemeUpdates } = action
  state.editable = extend(defaultColorScheme(), state.editable, colorSchemeUpdates)
  return state
}

export default colorScheme
